export const validatePass = (e, confirmPassword) => {
  let password = e.target.value;
  let capsCount,
    smallCount,
    numberCount,
    symbolCount,
    containsEightCharacters,
    containsBothCases,
    containsNumberAndSymbol,
    passwordsMatch,
    disableButton;
  capsCount = (password.match(/[A-Z]/g) || []).length;
  smallCount = (password.match(/[a-z]/g) || []).length;
  numberCount = (password.match(/\d/g) || []).length;
  symbolCount = (password.match(/[^\w\s]|_/g) || []).length;
  containsEightCharacters = password.length >= 8;
  containsBothCases = capsCount > 0 && smallCount > 0;
  containsNumberAndSymbol = numberCount > 0 && symbolCount > 0;
  passwordsMatch = password === confirmPassword;
  disableButton = !(
    containsEightCharacters &&
    containsBothCases &&
    containsNumberAndSymbol &&
    passwordsMatch
  );
  return {
    containsEightCharacters,
    containsBothCases,
    containsNumberOrSymbol: containsNumberAndSymbol,
    passwordsMatch,
    disableButton
  };
};
